module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "titletop n"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("ROWMAN & LITTLEFIELD PUBLISHERS, INC.")])]), _vm._v(" "), _c('p', {
    staticClass: "n topbottom1"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Published in the United States of America"), _c('br'), _vm._v("\n  by Rowman & Littlefield Publishers, Inc.")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("A wholly owned subsidiary of The Rowman & Littlefield Publishing Group, Inc."), _c('br'), _vm._v("\n  4501 Forbes Boulevard, Suite 200, Lanham, Maryland 20706"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.rowmanlittlefield.com",
      "target": "_blank"
    }
  }, [_vm._v("www.rowmanlittlefield.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "n topbottom1"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Estover Road")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Plymouth PL6 7PY"), _c('br'), _vm._v("\n  United Kindom")])]), _vm._v(" "), _c('p', {
    staticClass: "n topbottom1"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Copyright © 2007 by Rowman & Littlefield Publishers, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "left n topbottom1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "n topbottom1"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("British Library Cataloguing in Publication Information Available")])]), _vm._v(" "), _c('p', {
    staticClass: "n topbottom1"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "n"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Buchenau, Jürgen, 1964–")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Plutarco Elías Calles and the Mexican Revolution / Jürgen Buchenau.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("p. cm. — (Latin American silhouettes)")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Includes bibliographical references and index.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("ISBN-13: 978-0-7425-3748-4 (cloth : alk. paper)")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("ISBN-10: 0-7425-3748-X (cloth : alk. paper)")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("ISBN-13: 978-0-7425-3749-1 (pbk. : alk. paper)")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("ISBN-10: 0-7425-3749-8 (pbk. : alk. paper)")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("1. Calles, Plutarco Elías, 1877–1945. 2. Mexico—History—Revolution, 1910–1920. 3. Mexico—Politics and government—1910–1946. 4. Presidents—Mexico—")])]), _vm._v(" "), _c('p', {
    staticClass: "ext3"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Biography. I. Title.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext3"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("F1234.C192B83 2007"), _c('br'), _vm._v("\n  972.08'16092—dc22")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("2006024488")]), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "n topbottom1"
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "n left"
  }, [_c('img', {
    attrs: {
      "alt": "TM",
      "src": "Images/frn_fig_002.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("The paper used in this publication meets the minimum requirements of American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials, ANSI/NISO Z39.48-1992.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5f17752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Copyright.vue
// module id = 63
// module chunks = 0